import { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SmartContext } from '../../../library/Core/SmartContext';
import AlumniDirectoryService from './AlumniDirectoryService';

import { Tooltip } from 'bootstrap';
import { getStudentImage } from '../../../common/styles/Images';
import InitialsAvatar from '../../../library/SimpleControls/InitialsAvatar';
import { canExportToExcel, canSendDirectoryMessage, exportToExcel, formatFullName, getActionElementClass, getDirectorySendDisabledTooltip, getWhiteLabelUrl } from '../../../library/Core/SmartFunctions';
import CardBottom from './CardBottom';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import SessionContext from '../../../library/Core/SessionContext';

import GetStartedPromptModal from './GetStartedPromptModal';

const AlumniCardGridControl = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);

    const students = state.data.students;
    const pagination = (state.data as any).pagination;

    // Server-side pagination: state.data.students holds all pages fetched so far.
    // On scroll, fetchNextPage appends the next 50 records and updates pagination.hasMore.
    const [displayedStudents, setDisplayedStudents] = useState(students ?? []);
    const [hasMore, setHasMore] = useState(pagination?.hasMore ?? false);
    const [loadingMore, setLoadingMore] = useState(false);

    const fetchMoreStudents = async () => {
        if (!hasMore || loadingMore) return;
        setLoadingMore(true);
        await AlumniDirectoryService.fetchNextPage(state, dispatch);
        setLoadingMore(false);
    };

    // useEffect(() => {
    //     var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    //     var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //         return new Tooltip(tooltipTriggerEl);
    //     });
    // }, []);

    // console.log('State');
    // console.log(state.data);

    useEffect(() => {
        // Initialize tooltips when the component mounts
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('.btn-white-tooltip'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl, {
                customClass: 'tooltip-white'
            });
        });
    
        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, [displayedStudents,state?.data?.cardViewMode]);

    // Sync displayed students and hasMore whenever state updates (new page appended or filter reset).
    useEffect(() => {
        setDisplayedStudents(students ?? []);
        setHasMore(pagination?.hasMore ?? false);
    }, [students, pagination]);


    const noRecordsFound = () => (
        <div className="row g-2 g-md-4 alumni-showcase" id="FilterData">
            <div className="no_listed_items_blk">
                <div className="mt-0">
                    <div className="max-470 mx-auto">
                        <img
                            className="mt-2 mb-4 float_horizontal_animate"
                            src={`${process.env.REACT_APP_IMAGE_BASEPATH}/alumni_directory_nodata.svg`}
                        />
                        <p className="font-18 font-400 mb-4 text-center">
                            Looks like no alumni matching your search criteria has an active account yet!
                        </p>
                        {sessionStorage.getItem('user-type-code') == 'ALUMNI' && (
                            <div>
                                <p className="font-18 font-400 mb-4 text-center">
                                    Don’t worry! You can send invites to them and have them activate their profile on the network.
                                </p>
                                <div className="xscroll">
                                    <div className="d-block text-center mx-5 px-5">
                                        <a href="/alumni-invite/peer" className="btn-green height-40 text-white me-2">
                                            <span>Send Invite !</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    // const studentProfileLink = (uuid: string) => {
    //     const base_path=getWhiteLabelUrl(sessionState)
    //     const link = `${base_path}alumni/${uuid}/profile`;
    //     return link;
    // };

    const studentProfileLink = (uuid: string) => {
        const link = `/alumni/${uuid}/profile`;
        return link;
    };

    const handleNoImg = () => {
        return `${process.env.REACT_APP_IMAGE_BASEPATH}/no_university_img.svg`;
    };
    
    const geAlumniName = (student: any) => {
        return (
            `<div class="alumni_univarsity_brife">
                    <div class="alumni_univarsity_subject">
                        <span class="text-black">${formatFullName(student.firstName, student.lastName)}</span>
                    </div>
                </div>`
        );
    };

    if(localStorage.getItem('isEmailVerified') == 'undefined')
    {
        localStorage.removeItem('isEmailVerified');
        sessionStorage.removeItem('isEmailVerified');
    }

    const isEmailVerified: number = localStorage.getItem('isEmailVerified') ? Number(localStorage.getItem('isEmailVerified')) : 1;
    
    const showStar = (row: any) => (row.isNotable && row.isNotable == 1 ? true : false);

    const showExportButton = canExportToExcel(sessionState);

    const handleExportToExcel = () => exportToExcel(students, 'alumni-directory', state);

    const multipleCurrentRolesCount = Number(pagination?.multipleCurrentRolesCount ?? 0);
    const multipleCurrentRolesActive = (state.data as any)?.filters?.multipleCurrentRoles === 1;
    const showMultipleCurrentRoles = multipleCurrentRolesCount > 0 || multipleCurrentRolesActive;

    const toggleMultipleCurrentRoles = () => {
        const filters = (state.data as any)?.filters || {};
        AlumniDirectoryService.performSearchWithUserSelectedCriteria(
            {
                ...filters,
                multipleCurrentRoles: multipleCurrentRolesActive ? null : 1,
                context: { ...(filters.context || {}), page: 1 },
            },
            state,
            dispatch
        );
    };

    return (
        <section className="alumni_directory_details bg-white container-fluid">
            <div className="max-1140 pt-4 pb-5 mx-auto">
                <div className="row mb-3 align-items-center justify-content-between">
                    {/* 
                        <div className="col">
                            <h3 className='font-18 font-500 mt-3 mb-0'>Alumni Directory Name</h3>  this needs to be incorporated going forword 
                        </div> 
                    */}
                    <div className="col-auto d-flex align-items-center gap-2">
                        
                        <div className="alumni_count mt-0" id="UsersCounts">
                            {pagination?.total != null
                                ? `Showing ${displayedStudents.length} of ${pagination.total} Alumni`
                                : `${displayedStudents.length} Alumni Found`}
                        </div>
                    </div>
                    
                    {(showMultipleCurrentRoles || showExportButton) && (
                        <div className="col-auto d-flex align-items-center gap-2">
                            {showMultipleCurrentRoles && (
                                <button
                                    type="button"
                                    className={`btn rounded-pill d-inline-flex align-items-center gap-2 text-nowrap ${multipleCurrentRolesActive ? 'btn-success' : ''}`}
                                    style={
                                        multipleCurrentRolesActive
                                            ? { overflow: 'visible' }
                                            : { overflow: 'visible', background: '#fff', color: '#212529', border: '1px solid #ced4da' }
                                    }
                                    disabled={state?.flags?.isDataLoading}
                                    onClick={toggleMultipleCurrentRoles}>
                                    <span className="text-nowrap" style={{ color: 'inherit' }}>
                                        Multiple current roles
                                    </span>
                                    <span className={`badge rounded-pill ${multipleCurrentRolesActive ? 'bg-white text-success' : 'bg-success'}`}>
                                        {multipleCurrentRolesCount}
                                    </span>
                                </button>
                            )}
                            {showExportButton && (
                                <button
                                    className="btn btn-success d-flex align-items-center"
                                    disabled={state?.flags?.isDataLoading || !(students?.length > 0)}
                                    onClick={handleExportToExcel}>
                                    Export to Excel
                                </button>
                            )}
                        </div>
                    )}
                    
                </div>

                {
                    <InfiniteScroll dataLength={displayedStudents.length} next={fetchMoreStudents} hasMore={hasMore} loader={''}>
                        <div className="overflow-hidden">
                            <div className="row g-2 g-md-4 alumni-showcase">
                                {displayedStudents?.length > 0 &&
                                    displayedStudents?.map((student: any) => {
                                        // const university = universities.find(
                                        //     (university: any) => university.universityId === student.universityId
                                        // );

                                        return (
                                            // <AlumniGridWithCardsControl alumni={student} />
                                            <div key={student.uuid+' '+student.programName} className="col-lg-4 col-md-6 col-sm-6 Dusers">
                                                <div className="alumni-bucket">
                                                    <div className="alumni_class_link">
                                                        <div className="alumni_name_detail">
                                                            <div className="alumni_img overflow-visible">
                                                                <a
                                                                    className="alumni_img_link d-flex"
                                                                    href={studentProfileLink(student.uuid)}
                                                                    target="_blank"
                                                                    rel="noreferrer">
                                                                     <i className="position-relative">
                                                                    {student.profilePictureFilePath ? (
                                                                        <img
                                                                            className="img-fluid"
                                                                            src={getStudentImage(student)}
                                                                            alt={`${formatFullName(student.firstName, student.lastName)}`}
                                                                        />
                                                                    ) : (
                                                                        <InitialsAvatar firstName={student.firstName} lastName={student.lastName} />
                                                                    )}{showStar(student) && <i className="icon-star circle-img"></i>}</i>
                                                                </a>
                                                            </div>
                                                            <div className="alumni_name_brife">
                                                                <h3>
                                                                    <a
                                                                        className="btn-white-tooltip"
                                                                        href={studentProfileLink(student.uuid)}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        // data-bs-toggle="tooltip"
                                                                        // data-bs-html="true"
                                                                        // title=""
                                                                        // data-bs-original-title={geAlumniName(student)}
                                                                        >
                                                                       {`${formatFullName(student.firstName, student.lastName)}`}
                                                                    </a>

                                                                </h3>
                                                                <span className="alumni_campus">
                                                                    {student?.programName}, {student?.passOutYear}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="send_link d-flex align-items-center">
                                                        {isEmailVerified == 1 && canSendDirectoryMessage(student) ?
                                                            <GetStartedPromptModal
                                                             loginId={sessionState?.id}
                                                             userTypeCode={sessionState?.userTypeCode}
                                                             name={`${sessionState?.firstName} ${sessionState?.lastName}`}
                                                             programId={sessionState?.institutes?.[0]?.programId}
                                                             student={student}
                                                             className={`btn-send ${getActionElementClass()}`} imgWidth={506}/>
                                                            :
                                                            <a href="javascript:;" className="btn-send btn-white-tooltip" style={{background:'grey'}} data-bs-toggle="tooltip" data-bs-html="true" data-bs-original-title={getDirectorySendDisabledTooltip(isEmailVerified, student)}><i className="icon-alumni-send"></i><span>Send</span></a>
                                                        }
                                                        {student?.badges === 1 ? (
                                                            <a href="javascript:void(0)" className="btn-monitor ms-2">
                                                                <i className="icon-multiple-users"></i>
                                                            </a>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <CardBottom alumni={student} state={state} />
                                                    {/* <div className="alumni_univarsity_details">
                                                        <div className="alumni_univarsity_details_inner_cover">
                                                            <div className="alumni_univarsity_logo">
                                                                <img
                                                                    src={getUniversityImage(student?.collegeIconFilePath)}
                                                                    // alt={student?.universityName}
                                                                    alt={"No ..Image"}
                                                                />
                                                            </div>
                                                            <div className="alumni_univarsity_brife">
                                                                <div className="alumni_education">Course</div>
                                                                <div className="alumni_univarsity_name" data-bs-toggle="tooltip" title={student?.universityName}>
                                                                    {student?.universityName}
                                                                    {student?.isPrestigiousCollege == 1 && (
                                                                        <span className="icon-subtraction"></span>
                                                                    )}
                                                                </div>
                                                                <div className="alumni_univarsity_subject">
                                                                    <i></i>
                                                                    <span>{getFieldOfStudyName(student.fieldOfStudyCode, state)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </InfiniteScroll>
                }

                {!state?.flags.isDataLoading && students.length === 0 && noRecordsFound()}
            </div>
        </section>
    );
};

export default AlumniCardGridControl;
